import { queryOptions, useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { drillBlastSettingsAjax } from "../../ajax/DrillBlastSettingsAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { RootState } from "../../state/store";

export const drillBlastSettingsQuery = queryOptions({
  queryKey: ['references', 'drillBlast', 'settings'],
  queryFn: async () => {
    const res = await drillBlastSettingsAjax.getSettings();
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load drill and blast settings');
    return res;
  },
  staleTime: 5 * 60 * 1000,
});

export function useDrillBlastSettings() {
  return useQuery(drillBlastSettingsQuery);
}

const NO_MODULES: string[] = [];

// Note: what this deployment has bought, not what the user may do; like telemetryEnabled, absent reads as off.
export function useDrillBlastModules(): string[] {
  return useSelector((state: RootState) => state.authReducer.roleConfig?.drillBlast?.modules ?? NO_MODULES);
}
